/**
 * Frontend JavaScript for Map Block
 * Handles map initialization, markers, search, and interactions
 */

document.addEventListener('DOMContentLoaded', function() {
    // Wait for Mapbox to be available
    if (typeof mapboxgl === 'undefined') {
        console.error('Mapbox GL JS not loaded');
        return;
    }
    
    // Initialize all map blocks on the page
    const mapContainers = document.querySelectorAll('.mapbox-container[data-block-id]');
    
    mapContainers.forEach(container => {
        initializeMap(container);
    });
});

function initializeMap(container) {
    const blockId = container.dataset.blockId;
    const containerId = container.id;
    const mapboxToken = container.dataset.mapboxToken;
    const center = JSON.parse(container.dataset.center);
    const zoom = parseInt(container.dataset.zoom);
    const showMemberMap = container.dataset.showMemberMap === '1';
    const members = JSON.parse(container.dataset.members || '[]');
    const pins = JSON.parse(container.dataset.pins || '[]');
    
    // Set Mapbox access token
    mapboxgl.accessToken = mapboxToken;
    
    // Initialize map
    const map = new mapboxgl.Map({
        container: containerId,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: center,
        zoom: zoom
    });
    
    // Add error handling
    map.on('error', function(e) {
        console.error('Mapbox error:', e);
    });
    
    // Wait for map to load before adding markers
    map.on('load', function() {
        console.log('Map loaded successfully');
    });

    let markers = [];
    let popups = [];
    let markerElements = [];

    if (showMemberMap && members.length > 0) {
        // Member Map Implementation
        members.forEach(function(member, index) {
            const el = document.createElement('div');
            el.className = 'marker member-marker';
            el.style.backgroundImage = 'url("/wp-content/themes/jormi/assets/images/map-pin.svg")';
            el.style.backgroundSize = 'contain';
            el.style.backgroundRepeat = 'no-repeat';
            el.style.backgroundPosition = 'center bottom';
            el.style.width = '2.5rem';
            el.style.height = '2.5rem';
            el.style.cursor = 'pointer';
            el.dataset.memberId = member.id;
            el.dataset.memberTitle = member.title.toLowerCase();

            const marker = new mapboxgl.Marker(el)
                .setLngLat([member.longitude, member.latitude])
                .addTo(map);

            const popup = new mapboxgl.Popup({
                closeButton: true,
                closeOnClick: false,
                offset: [0, -30],
                maxWidth: '300px'
            });

            markers.push(marker);
            popups.push(popup);
            markerElements.push(el);

            // Build popup HTML
            let popupHTML = '<div class="member-popup">';
            popupHTML += '<h4 class="text-inherit mt-0 mb-2">' + member.title + '</h4>';
            
            if (member.province) {
                popupHTML += '<p class="text-sm mb-2"><strong>Province:</strong> ' + member.province.toUpperCase() + '</p>';
            }
            
            if (member.website) {
                popupHTML += '<a href="' + member.website + '" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline text-sm">Visit Website &rarr;</a>';
            }
            
            popupHTML += '</div>';

            // Track if popup was opened by click
            let clickedOpen = false;
            let hoverTimeout;
            
            // Click event
            el.addEventListener('click', function(e) {
                e.stopPropagation();
                
                // Close all other popups
                popups.forEach(p => p.remove());
                
                popup.setLngLat([member.longitude, member.latitude])
                    .setHTML(popupHTML)
                    .addTo(map);
                
                clickedOpen = true;
                
                // Center map on marker
                map.flyTo({
                    center: [member.longitude, member.latitude],
                    zoom: Math.max(map.getZoom(), 8)
                });
            });

            // Hover events
            el.addEventListener('mouseenter', function() {
                if (!clickedOpen) {
                    clearTimeout(hoverTimeout);
                    popup.setLngLat([member.longitude, member.latitude])
                        .setHTML(popupHTML)
                        .addTo(map);
                    
                    // Add hover listeners to popup after it's added
                    setTimeout(() => {
                        const popupEl = popup.getElement();
                        if (popupEl) {
                            popupEl.addEventListener('mouseenter', function() {
                                clearTimeout(hoverTimeout);
                            });
                            
                            popupEl.addEventListener('mouseleave', function() {
                                hoverTimeout = setTimeout(() => {
                                    if (!clickedOpen) {
                                        popup.remove();
                                    }
                                }, 200);
                            });
                        }
                    }, 50);
                }
            });

            el.addEventListener('mouseleave', function() {
                if (!clickedOpen) {
                    hoverTimeout = setTimeout(() => {
                        popup.remove();
                    }, 200);
                }
            });
            
            // Listen for popup close button
            popup.on('close', function() {
                clickedOpen = false;
            });
        });

        // Search functionality
        const searchInput = document.getElementById('member-search-' + blockId);
        const searchResults = document.getElementById('search-results-' + blockId);
        
        if (searchInput && searchResults) {
            searchInput.addEventListener('input', function(e) {
                const searchTerm = e.target.value.toLowerCase().trim();
                
                if (searchTerm.length < 2) {
                    searchResults.classList.add('hidden');
                    searchResults.innerHTML = '';
                    
                    // Show all markers
                    markerElements.forEach(el => {
                        el.style.display = 'block';
                    });
                    return;
                }
                
                // Filter members
                const filtered = members.filter(m => 
                    m.title.toLowerCase().includes(searchTerm) ||
                    (m.province && m.province.toLowerCase().includes(searchTerm))
                );
                
                // Hide/show markers based on search
                markerElements.forEach(el => {
                    const memberId = parseInt(el.dataset.memberId);
                    const isMatch = filtered.some(m => m.id === memberId);
                    el.style.display = isMatch ? 'block' : 'none';
                });
                
                // Display search results
                if (filtered.length > 0) {
                    searchResults.classList.remove('hidden');
                    let resultsHTML = '';
                    filtered.forEach(function(m) {
                        resultsHTML += '<div class="search-result-item p-3 hover:bg-gray-100 cursor-pointer border-b last:border-b-0" data-member-id="' + m.id + '">';
                        resultsHTML += '<div class="font-semibold">' + m.title + '</div>';
                        if (m.province) {
                            resultsHTML += '<div class="text-sm text-gray-600">' + m.province.toUpperCase() + '</div>';
                        }
                        resultsHTML += '</div>';
                    });
                    searchResults.innerHTML = resultsHTML;
                    
                    // Add click handlers to results
                    searchResults.querySelectorAll('.search-result-item').forEach((item, idx) => {
                        item.addEventListener('click', function() {
                            const memberId = parseInt(this.dataset.memberId);
                            const member = filtered.find(m => m.id === memberId);
                            
                            if (member) {
                                const markerEl = markerElements.find(el => 
                                    parseInt(el.dataset.memberId) === memberId
                                );
                                
                                if (markerEl) {
                                    markerEl.click();
                                }
                                
                                searchResults.classList.add('hidden');
                                searchInput.value = '';
                            }
                        });
                    });
                } else {
                    searchResults.classList.remove('hidden');
                    searchResults.innerHTML = '<div class="p-3 text-gray-500 text-center">No members found</div>';
                }
            });
            
            // Keyboard navigation for search results
            let currentFocus = -1;
            
            searchInput.addEventListener('keydown', function(e) {
                const items = searchResults.querySelectorAll('.search-result-item');
                
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    currentFocus++;
                    addActive(items);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    currentFocus--;
                    addActive(items);
                } else if (e.key === 'Enter') {
                    e.preventDefault();
                    if (currentFocus > -1 && items[currentFocus]) {
                        items[currentFocus].click();
                    }
                } else if (e.key === 'Escape') {
                    searchResults.classList.add('hidden');
                    currentFocus = -1;
                }
            });
            
            function addActive(items) {
                if (!items.length) return;
                removeActive(items);
                
                if (currentFocus >= items.length) currentFocus = 0;
                if (currentFocus < 0) currentFocus = items.length - 1;
                
                items[currentFocus].classList.add('search-active');
                items[currentFocus].scrollIntoView({ block: 'nearest' });
            }
            
            function removeActive(items) {
                items.forEach(item => item.classList.remove('search-active'));
            }
            
            // Close search results when clicking outside
            document.addEventListener('click', function(e) {
                if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
                    searchResults.classList.add('hidden');
                }
            });
        }

    } else {
        // Custom Pins Implementation
        pins.forEach(function(pin, index) {
            const el = document.createElement('div');
            el.className = 'marker';
            el.style.backgroundImage = 'url("/wp-content/themes/jormi/assets/images/map-pin.svg")';
            el.style.backgroundSize = 'contain';
            el.style.backgroundRepeat = 'no-repeat';
            el.style.backgroundPosition = 'center bottom';
            el.style.width = '2.5rem';
            el.style.height = '2.5rem';
            el.style.cursor = 'pointer';

            const marker = new mapboxgl.Marker(el)
                .setLngLat([parseFloat(pin.longitude), parseFloat(pin.latitude)])
                .addTo(map);

            const popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
                offset: [0, -30]
            });

            markers.push(marker);
            popups.push(popup);
            markerElements.push(el);

            const popupHTML = '<h4 class="text-inherit mt-0">' + pin.title + '</h4>' + 
                             (pin.address ? pin.address : '');

            el.addEventListener('click', function(e) {
                e.stopPropagation();
                popup.setLngLat([parseFloat(pin.longitude), parseFloat(pin.latitude)])
                    .setHTML(popupHTML)
                    .addTo(map);
            });

            el.addEventListener('mouseenter', function() {
                popup.setLngLat([parseFloat(pin.longitude), parseFloat(pin.latitude)])
                    .setHTML(popupHTML)
                    .addTo(map);
            });

            el.addEventListener('mouseleave', function() {
                popup.remove();
            });
        });
    }

    // Close opened popups on map click
    map.on('click', function(e) {
        const clickedOnMarker = markerElements.some(function(markerEl) {
            return e.originalEvent.target === markerEl || markerEl.contains(e.originalEvent.target);
        });
        
        if (!clickedOnMarker) {
            popups.forEach(function(popup) {
                popup.remove();
            });
        }
    });
    
    // Add keyboard accessibility for markers
    setTimeout(() => {
        markerElements.forEach((marker, index) => {
            marker.setAttribute('role', 'button');
            marker.setAttribute('tabindex', '0');
            marker.setAttribute('aria-label', 'Location marker ' + (index + 1));
            
            // Add keyboard support
            marker.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    marker.click();
                }
            });
        });
    }, 500);
}

// Helper function to reset map view
window.resetMapView = function(blockId) {
    const event = new CustomEvent('resetMapView', { detail: { blockId } });
    document.dispatchEvent(event);
};

// Helper function to focus on specific member
window.focusMember = function(blockId, memberId) {
    const event = new CustomEvent('focusMember', { 
        detail: { blockId, memberId } 
    });
    document.dispatchEvent(event);
};